import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	breadcrumb: {
		marginTop: theme.spacing(4) + "px !important",
		"& .mco-breadcrumb": {
			flexWrap: "wrap",
			columnGap: theme.spacing(1),
			paddingRight: theme.spacing(4),
			rowGap: theme.spacing(1)
		},
		"& .mco-breadcrumb-item:first-child .mco-breadcrumb-item__label": {
			display: "none"
		},
		"& .mco-breadcrumb-item__link, .mco-breadcrumb-item__page": {
			gap: theme.spacing(1),
			"&.mco-link--active, &:hover": {
				"& .mco-breadcrumb-item__label": {
					color: theme.palette.secondary.dark
				}
			}
		},
		"& .mco-breadcrumb-item__label": {
			color: theme.palette.text.secondary,
			fontFamily: "Sofia Sans !important",
			textTransform: "uppercase",
			transition: "color 250ms ease"
		},
		[theme.breakpoints.up("md")]: {
			"& .mco-breadcrumb": {
				columnGap: theme.spacing(2)
			},
			"& .mco-breadcrumb-item__link, .mco-breadcrumb-item__page": {
				gap: theme.spacing(2)
			}
		}
	},
	homeIcon: {
		"& svg": {
			"& path": {
				fill: theme.palette.text.secondary
			}
		}
	},
	separator: {
		background: theme.palette.divider,
		display: "block",
		height: 16,
		width: 1
	}
}));

export default styles;
